import NewsTagIndex from './NewsTagIndex';
import NewsTagCreate from './NewsTagCreate';
import NewsTagSettings from './NewsTagSettings';
import NewsTagSingle from './NewsTagSingle';

export default function (app) {

    const settings = NewsTagSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 14,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    NewsTagIndex(app, settings);

    NewsTagCreate(app, settings);

    NewsTagSingle(app, settings);

}